export default {
  show(text, type, display) {
    this.$store.commit('showAlert', {text, type, display});
  }
}
